import React, { useState, useEffect } from "react";
import StatusDropdown from "./StatusDropdown";
import FullfillmentDropdown from "./FullfillmentDropdown";

const columnList = [
	{
		title: "ID",
		name: "id",
		width: "10",
	},
	{
		title: "Customer",
		name: "customer",
		width: "14",
	},
	{
		title: "Status",
		name: "status",
		width: "15",
	},
	{
		title: "Fulfillment",
		name: "fulfillment",
		width: "15",
	},
	{
		title: "Products",
		name: "items",
		width: "10",
	},
	{
		title: "Amount",
		name: "total",
		width: "13",
	},
	{
		title: "Transactions ID",
		name: "transactions",
		width: "13",
	},
	{
		title: "Date & Time",
		name: "created_at",
		width: "10",
	},
];

const statusOptions = [
	{ label: "Completed", value: "completed" },
	{ label: "Cancelled", value: "cancelled" },
	{ label: "Partially Refunded", value: "partially_refunded" },
	{ label: "Refunded", value: "refunded" },
	{ label: "Pending", value: "pending" },
	{ label: "On hold", value: "on_hold" },
	{ label: "Processing", value: "processing" },
	// { label: "Failed", value: "failed" },
];

const OrderTable = ({
	tableColumns,
	orders,
	setOrderIdToDelete,
	setShowModal,
	selectedOrders,
	handleSelectOne,
	handleSelectAll,
	setIsBulkDelete,
	setAllShowModal,
	isBulkSelection,
	setOrders,
	setStatusCounts,
	setOrderToDeleteStatus
	
}) => {
	const paymentMethods = EASYCOMMERCE.payment_methods;
	const allSelected = orders.length > 0 && selectedOrders.length === orders.length;


	return (
		<div className="w-full overflow-x-auto h-full">
			<table className="min-w-full xl:min-w-[1300px] w-full border-collapse border-spacing-0"> 
				<thead>
					<tr className="h-auto">
						{columnList.map((item, index) => {
							if (!tableColumns.includes(item.name)) return null;

							if (item.name === 'id') {
								return (
									<th
										key={index}
										className="p-3 pl-5 flex bg-ec-modal items-center justify-start gap-2 rounded-l-md border-r-0"
									>
										<input
											type="checkbox"
											checked={allSelected}
											onChange={(e) => handleSelectAll(e.target.checked)}
											className="min-w-5 h-5 accent-ec-primary cursor-pointer mr-2 easycommerce-input-checkoutbox pl-2"
										/>

										<span className="ml-2 font-inter font-normal text-sm text-ec-title">
											ID
										</span>
									</th>
								);
							}
							return (
								<th
									key={index}
									className={`font-inter font-normal pl-5 bg-ec-modal text-sm text-ec-title cursor-pointer text-left 
									lg:w-[${item.width}%] ${item.name === 'created_at' ? 'rounded-r-md' : ''}`}
								>
									{item.title}
								</th>
							);
						})}
					</tr>
				</thead>
				<tbody>
					{orders.map((order) => (
						<tr key={order.id} className="group border-b border-ec-table-stock h-[80px] transition-shadow hover:shadow-[0px_4px_40px_0px_#00000014]">
							{tableColumns.includes("id") && (
								<td className="lg:w-[10%] leading-[26px] pl-5 h-[80px]">
									<div className="flex items-center w-full h-full">
										<input
											type="checkbox"
											checked={selectedOrders.includes(order.id)}
											onChange={() => handleSelectOne(order.id)}
											className="min-w-5 h-5 accent-ec-primary cursor-pointer mr-2 easycommerce-input-checkoutbox pl-2"
										/>
										<div className="relative w-full h-ec-input ml-[10px]">
											<div className="flex absolute left-0 top-1/2 -translate-y-1/2 group-hover:top-4 duration-300">
												<span
													className="font-inter font-normal text-sm lg:text-[14px] md:text-sm text-ec-body">
													{`#${order.id}`}
												</span>
											</div>
											<div className="absolute bottom-0 flex items-center gap-1.5 font-inter font-normal text-xs text-ec-light-black opacity-0 group-hover:opacity-100 duration-300">
												<button 
													className="hover:text-ec-primary duration-300"
													onClick={() => (window.location.hash = `#/orders/${order.id}`)}
												>
														View
												</button>
												<span className="text-[#bdbdbd]">|</span>
												<button 
													className="text-ec-red"
													onClick={() => {
														setOrderIdToDelete(order.id);
														setOrderToDeleteStatus(order.status);
														setShowModal(true);
													}}
												>
													Delete
												</button>
											</div>
										</div>
									</div>
								</td>
							)}
							{tableColumns.includes("customer") && (
								<td className="w-[14%] pl-5 font-inter font-normal lg:text-[14px] md:text-sm">
									<a
										href={`#/customers/${order.customer?.id}`}
										className="text-ec-body hover:text-ec-body focus:shadow-none focus:outline-none">
										<span className="pb-1">
											{order.customer?.name}
										</span>
									</a>
								</td>
							)}
							{tableColumns.includes("status") && (
								<td className="w-[15%] pl-5">
									<div className="flex items-center gap-2">
										<StatusDropdown
											options={statusOptions}
											orderId={order.id}
											value={order?.status}
											placeholder="Select status"
											width="auto"
											menuWidth="150px"
											prevStatus={order?.status}
											onStatusChange={(prev, next) => {
												setOrders((orders) =>
													orders.map((ord) =>
														ord.id === order.id
															? { ...ord, status: next }
															: ord
													)
												);
												setStatusCounts((counts) => {
													const updated = { ...counts };

													if (prev && updated[prev] > 0) {
														updated[prev] -= 1;
													}

													if (next) {
														updated[next] = (updated[next] || 0) + 1;
													}

													return updated;
												});
											}}
										/>
									</div>
								</td>
							)}
							{tableColumns.includes("fulfillment") && (
								<td className="font-inter font-normal pl-5 lg:text-sm text-ec-body md:text-[14px] w-[15%] relative overflow-visible">
									<div className="flex items-center gap-2">
										<FullfillmentDropdown
											orderId={order.id}
											value={order?.fulfill_status}
											placeholder="Select status"
											width="116px"
											menuWidth="150px"
											prevStatus={order?.fulfill_status}
											onStatusChange={(prev, next) => {
												setOrders((orders) =>
													orders.map((ord) =>
														ord.id === order.id
															? { ...ord, fulfill_status: next }
															: ord
													)
												);
											}}
										/>
									</div>
								</td>
							)}
							{tableColumns.includes("items") && (
								<td className="font-inter font-normal pl-5 lg:text-sm text-ec-body md:text-[14px] lg:w-[10%]">
									{order?.items}
								</td>
							)}
							{tableColumns.includes("total") && (
								<td className="font-inter font-normal pl-5 lg:text-sm text-ec-body md:text-[14px] lg:w-[13%]">
									{EASYCOMMERCE.currency_symbol}{order?.total}
								</td>
							)}
							{tableColumns.includes("transactions") &&
								(order.transactions.length > 0 ? (
									(() => {
										const txn =
											order.transactions[
												order.transactions.length - 1
											];
										const paymentGateway =
											txn.payment_gateway
												? txn.payment_gateway.toLowerCase()
												: "unknown";
										const paymentMethod =
											paymentMethods[paymentGateway];
										const paymentIcon =
											paymentMethod?.icon;
										const maxLength = 6;
										let transactionId =
											txn.transaction_id || "**** ****";
										if (transactionId.length > maxLength) {
											transactionId = `...${transactionId.substring(
												transactionId.length - maxLength
											)}`;
										}
										
										return (
											<td
												key={txn.id}
												className="flex items-center gap-2 mr-2 pl-5 py-[20px] text-sm lg:w-[13%]"
											>
												{paymentIcon ? (
													<img
														src={paymentIcon}
														className="pointer-events-none object-contain rounded h-[30px] min-w-[54px] p-[3px]"
														alt="payment-icon"
														style={{ border: "1px solid #f0edfb" }}
													/>
												) : (
													<span className="text-ec-body font-inter text-sm font-normal text-center border rounded border-ec-table-stock h-[30px] min-w-[54px] p-[3px]">
														{txn.payment_gateway}
													</span>
												)}

												<p className="text-ec-body font-inter text-sm font-normal leading-[26px]">
													{transactionId && transactionId !== "-" ? transactionId : ""}
												</p>
											</td>
										);
									})()
								) : (
									<td className="text-left py-4 font-inter pl-5 font-normal lg:w-[13%] lg:text-sm 
										text-ec-body md:text-[14px]">
										N/A
									</td>
								)
							)}

							{tableColumns.includes("created_at") && (
								<td className="lg:w-[10%] pl-5">
									<div className="flex flex-col">
										<p className="font-inter font-normal mb-1 lg:text-sm text-ec-body md:text-[14px]">
											{order.created_at ? order.created_at : "N/A"}
										</p>
										<span className="text-ec-placeholder text-sm font-inter leading-4">
											{order.created_time ? order.created_time : "N/A"}
										</span>
									</div>
								</td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default OrderTable;
